var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossWhiteBackgroundGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0594 10.0004L13.3594 7.70034C13.6494 7.41034 13.6494 6.93035 13.3594 6.64035C13.0694 6.35035 12.5894 6.35035 12.2994 6.64035L9.99939 8.94036L7.69936 6.64035C7.40936 6.35035 6.92937 6.35035 6.63938 6.64035C6.34938 6.93035 6.34938 7.41034 6.63938 7.70034L8.93938 10.0004L6.63938 12.3004C6.34938 12.5904 6.34938 13.0704 6.63938 13.3604C6.78938 13.5104 6.97937 13.5804 7.16937 13.5804C7.35937 13.5804 7.54936 13.5104 7.69936 13.3604L9.99939 11.0604L12.2994 13.3604C12.4494 13.5104 12.6394 13.5804 12.8294 13.5804C13.0194 13.5804 13.2094 13.5104 13.3594 13.3604C13.6494 13.0704 13.6494 12.5904 13.3594 12.3004L11.0594 10.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhiteBackgroundGrey);
export default __webpack_public_path__ + "static/media/cross-white-background-grey.b73e8fafe68856838b51bc347fe14776.svg";
export { ForwardRef as ReactComponent };